module.exports = __webpack_public_path__ + "img/PorkCanada.2f6f128a.png";